if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.mqlSmall = window.matchMedia('(max-width: 749px)');
        this.form = this.querySelector('form');
        if (this.form) {
          const idInput = this.form.querySelector('[name=id]');
          if (idInput) idInput.disabled = false;
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        this.cartNotification = document.querySelector('cart-notification');
        this.cartDrawer = document.querySelector('cart-drawer');
        this.carts = [this.cartNotification, this.cartDrawer].filter(Boolean);
        this.submitButton = this.querySelector('[type="submit"]');
        // this.quickAdd = this.closest('[data-quick-add]');
        this.quickAdd = false;
        this.formAnalyticsId = this.dataset.formAnalytics || "undefined";
        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton?.setAttribute('aria-disabled', true);

        if (this.quickAdd) {
          this.quickAdd.classList.add('loading');
          this.quickAdd.querySelector('.loading__spinner')?.classList.remove('hidden');
        } else {
          this.submitButton?.classList.add('loading');
          this.querySelector('.loading__spinner')?.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.carts.length) {
          let sectionIds = [];
          let currentCart = this.cartDrawer;

          if (this.cartDrawer) {
            this.cartDrawer.getSectionsToRender().forEach((section) => {
              sectionIds.push(section.id);
            });
          }

          if (
            this.cartNotification &&
            (this.mqlSmall.matches || !this.cartDrawer)
          ) {
            this.cartNotification.getSectionsToRender().forEach((section) => {
              sectionIds.push(section.id);
            });

            currentCart = this.cartNotification;
          }

          formData.append('sections', sectionIds);
          formData.append('sections_url', window.location.pathname);
          currentCart?.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (!response.status) {
              this.sendAnalyticsData(response);
            }

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id') || formData.get('items[0][id]'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
              if (soldOutMessage || this.quickAdd) {
                this.submitButton?.setAttribute('aria-disabled', true);
                this.error = true;
              }
              if (!soldOutMessage) return;
              this.submitButton?.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              return;
            } else if (!this.carts.length) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;

            if (this.cartDrawer) {
              let open = false;
              if (!this.cartNotification || !this.mqlSmall.matches) open = true;

              this.cartDrawer.renderContents(response, open);
            }

            if (
              this.cartNotification &&
              (!this.cartDrawer || this.mqlSmall.matches)
            ) {
              this.cartNotification.renderContents(response);
            }

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.quickAdd) {
              this.quickAdd.classList.remove('loading');
              this.quickAdd.querySelector('.loading__spinner')?.classList.add('hidden');
            } else {
              this.submitButton?.classList.remove('loading');
              this.querySelector('.loading__spinner')?.classList.add('hidden');
            }

            if (this.carts.length) {
              this.carts.forEach(cart => {
                if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              });
            }
            if (!this.error) this.submitButton?.removeAttribute('aria-disabled');
          });
      }

      sendAnalyticsData(cartResponse) {
        let analyticsItems = (cartResponse.items || [cartResponse]).map((item) => {
          return {
            item_id: item.sku,
            item_name: item.product_title,
            affiliation: "Shopify Store",
            item_brand: item.vendor,
            item_category: item.product_type,
            item_variant: item.variant_title,
            item_sku: item.sku,
            price: item.final_price,
            quantity: 1
          }
        });

        document.dispatchEvent(new CustomEvent('analytics_add_to_cart', {
          detail: {
            eventData: {
              event: "add_to_cart",
              source: "custom",
              form_id: this.formAnalyticsId,
              currency: Shopify.currency.active,
              value: cartResponse.price,
              items: analyticsItems
            }
          }
        }));
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
